import React from 'react';
import { textareaPropTypes } from './TextareaPropTypes';
const Textarea = ({
  name,
  placeholder,
  required,
  classname
}) => /*#__PURE__*/React.createElement("textarea", {
  placeholder: placeholder,
  className: classname || '',
  name: name,
  required: required || null
});
export default Textarea;